<iot-platform-ui-async-autocomplete
  (reset)="onReset()"
  (search)="onSearch($event)"
  (selectionChanged)="onSelect($event)"
  [autocomplete]="true"
  [clearOnSelect]="clearOnSelect()"
  [data]="filteredItems()"
  [debounceTime]="300"
  [disableOnlyOptions]="disableOnlyOptions()"
  [disabled]="disabled()"
  [displaySearchIcon]="false"
  [displayWrapper]="displayWrapper.bind(this)"
  [errorMessage]="errorMessage()"
  [initialItem]="selectedCountry()"
  [minLength]="0"
  [placeholder]="placeholder() | translate"
  [required]="required()"
  displayKey="name.common"
  fxFlex
/>
